
class Storage {
  constructor() {
    this.storageName = "expiredStorage";
  }
  // name缓存名称
  // value缓存的值
  // expires缓存过期时间 单位秒
  /**
   *  设置缓存
   *  @param {string} name 缓存名称
   *  @param {any} value 缓存的值
   *  @param {any} expires 缓存过期时间(秒)
   **/
  set(name, value, expires) {
    expires = STORAGE_TIME;
    const storages = {};
    storages[name] = {
      value,
      expires: storages[name]
        ? storages[name].expires
        : expires === undefined
        ? +new Date() + 31536000000
        : expires * 1000 + +new Date(),
    };
    localStorage.setItem(this.storageName, JSON.stringify(storages));
  }
  get(name) {
    const storages = JSON.parse(localStorage.getItem(this.storageName));
    try {
      if (!storages[name]) {
        return null;
      }
      console.log("log=====", storages[name].expires - new Date());
      if (+new Date() > storages[name].expires) {
        // 存在但过期
        this.remove(name);
        return null;
      }
      return storages[name].value;
    } catch (error) {
      console.log(
        "[ControlStorage] the error message: get field failed\n",
        error
      );
    }
  }
  remove(name) {
    const storages = JSON.parse(localStorage.getItem(this.storageName));
    try {
      delete storages[name];
      if (JSON.stringify(storages) === "{}") {
        // 缓存字段为空对象时，删除该字段
        this.clear();
        return;
      }
      this.baseStorage.setItem(storages);
    } catch (error) {
      console.log(
        "[ControlStorage] the error message: remove field failed\n",
        error
      );
    }
  }
  clear() {
    localStorage.removeItem(this.storageName);
  }
}

export default new Storage();
